import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import texts from './texts.json';
import {
  Container,
  IconCircle,
  StyledCheckIcon,
  Texts,
  Title,
  Subtitle,
} from './styles';

/** Confirms the purchase just made, so nothing shown after it can be mistaken for a step still to pay for. */
const PaymentConfirmedBanner = ({ amount, productName, isDarkTheme }) => (
  <Container role="status" $isDarkTheme={isDarkTheme}>
    <IconCircle>
      <StyledCheckIcon aria-hidden="true" />
    </IconCircle>
    <Texts>
      <Title $isDarkTheme={isDarkTheme}>{format(texts.title, { amount })}</Title>
      <Subtitle>{format(texts.subtitle, { productName })}</Subtitle>
    </Texts>
  </Container>
);

PaymentConfirmedBanner.propTypes = {
  amount: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  isDarkTheme: PropTypes.bool,
};

PaymentConfirmedBanner.defaultProps = {
  isDarkTheme: false,
};

export default PaymentConfirmedBanner;
